import { Theme } from '@material-ui/core';
import { AlertClassKey } from '@material-ui/lab/Alert';

const MuiAlert = (theme: Theme): Partial<Record<AlertClassKey, unknown>> => ({
    root: {
        color: theme.palette.text.primary,
    },
    filledWarning: {
        color: theme.palette.warning.contrastText,
    },
    filledInfo: {
        color: theme.palette.info.contrastText,
    },
    filledSuccess: {
        color: theme.palette.success.contrastText,
    },
    filledError: {
        color: theme.palette.error.contrastText,
    },
    standardWarning: {
        color: theme.palette.text.primary,
    },
    standardInfo: {
        color: theme.palette.text.primary,
    },
    standardSuccess: {
        color: theme.palette.text.primary,
    },
    standardError: {
        color: theme.palette.text.primary,
    },
    outlinedWarning: {
        color: theme.palette.text.primary,
    },
    outlinedInfo: {
        color: theme.palette.text.primary,
    },
    outlinedSuccess: {
        color: theme.palette.text.primary,
    },
    outlinedError: {
        color: theme.palette.text.primary,
    },
});

export default MuiAlert;
